module.exports = __webpack_public_path__ + "img/horizontal_3_1_5010.a0b9f11d.png";